import React from 'react';
import { useTranslation } from 'react-i18next';
import FadeAnimation from 'components/atoms/base-animations/fade';

import ClinicInvoicesInfoEditForm from './edit-form';
import ClinicInvoicesInfoViewForm from './view-form';
import s from './styles.module.scss';

import type { IClinicInvoiceInfo } from 'infrastructure/interfaces';

interface IProps {
  data: IClinicInvoiceInfo;
  isEdit: boolean;
  isDisabled: boolean;
  onSave: (data: IClinicInvoiceInfo) => void;
}

const ClinicInvoicesInfoForm: React.FC<IProps> = (props) => {
  const { t } = useTranslation();

  const { data, isEdit, isDisabled, onSave } = props;

  return (
    <div className={s.wrapper}>
      <p className={s.title}>{t('labels.generalInformation')}</p>
      <FadeAnimation uniqueKey={`${isEdit}`}>
        {isEdit ? (
          <ClinicInvoicesInfoEditForm
            data={data}
            isDisabled={isDisabled}
            onSave={onSave}
          />
        ) : (
          <ClinicInvoicesInfoViewForm data={data} />
        )}
      </FadeAnimation>
    </div>
  );
};

export default ClinicInvoicesInfoForm;
